(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusDetailController', CrmOutboundReferralStatusDetailController);

    CrmOutboundReferralStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CrmOutboundReferralStatus', 'Corporation'];

    function CrmOutboundReferralStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, CrmOutboundReferralStatus, Corporation) {
        var vm = this;

        vm.crmOutboundReferralStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:crmOutboundReferralStatusUpdate', function(event, result) {
            vm.crmOutboundReferralStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
